async function fetchAndReplaceProductGrid(url) {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        const productGridContainer = doc.querySelector('.collection');
        // const productGridContainer = doc.getElementById('ProductGridContainer');
      

        if (productGridContainer) {
            // console.log(productGridContainer);
            const targetContainer = document.querySelector(".collection");
            // const targetContainer = document.getElementById("ProductGridContainer");
            // console.log(targetContainer);
            const productGrid = targetContainer.querySelector('.product-grid');
          if(productGrid.querySelectorAll('li').length == 16) {
            console.log('i have 16 elemnt')
            targetContainer.innerHTML = productGridContainer.innerHTML;
            return;
          }
          if(productGrid.querySelectorAll('li').length < 16){
            console.log('i have less then 16 elemnet');
            targetContainer.innerHTML = productGridContainer.innerHTML;
            document.querySelector('.peginate-url').style.display = "none";
            return;
          }else{
             document.querySelector('.peginate-url').style.display = "none";
            return;
          }
            
            // console.log('Done')
        } else {
            console.log('Element with id "ProductGridContainer" not found in the response.');
        }
    } catch (error) {
        console.error('An error occurred:', error);
    }
}


const selectElement = document.querySelectorAll('#sort-by-Filter');

selectElement.forEach(selectElement => {
    selectElement.addEventListener('change', function () {
        const selectedValue = selectElement.value;
        // Get the current URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Update or add the 'sort_by' parameter with the selected value
        urlParams.set('sort_by', selectedValue);

        // Update the URL with the new parameters
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.pushState({}, '', newUrl);
        fetchAndReplaceProductGrid(newUrl);
    });
});
// // Get a reference to the select element
// var selectElement = document.getElementById('sort-by-Filter');

// // Add event listener to handle value change
// selectElement.addEventListener('change', function() {
//   var selectedValue = selectElement.value;
  
//   // Get the current URL parameters
//   var urlParams = new URLSearchParams(window.location.search);
  
//   // Update or add the 'sort_by' parameter with the selected value
//   urlParams.set('sort_by', selectedValue);
  
//   // Update the URL with the new parameters
//   var newUrl = window.location.pathname + '?' + urlParams.toString();
//   window.history.pushState({}, '', newUrl);
//   fetchAndReplaceProductGrid(newUrl);
// });

// // Get a reference to the select element
// var selectElement2 = document.getElementById('sort-by');

// // Add event listener to handle value change
// selectElement2.addEventListener('change', function () {
//   console.log('I am here');
//   var selectedValue = selectElement2.value;

//   // Get the current URL parameters
//   var urlParams = new URLSearchParams(window.location.search);

//   // Update or add the 'sort_by' parameter with the selected value
//   urlParams.set('sort_by', selectedValue);

//   // Update the URL with the new parameters
//   var newUrl = window.location.pathname + '?' + urlParams.toString();
//   window.history.pushState({}, '', newUrl);
//   fetchAndReplaceProductGrid(newUrl);
// });




const options = document.getElementsByClassName('option');

Array.from(options).forEach(element => {
    // Add click event listener
    element.addEventListener('click', function () {
        // Toggle .borderadd class
        this.classList.toggle('borderadd');
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const name = this.getAttribute('name');
        const value = this.getAttribute('value');

        const existingParamValues = urlParams.getAll(name);

        if (existingParamValues.includes(value)) {
            // Remove the value if it exists
            const updatedValues = existingParamValues.filter(paramValue => paramValue !== value);
            urlParams.delete(name);
            updatedValues.forEach(updatedValue => urlParams.append(name, updatedValue));
        } else {
            // Add the value
            urlParams.append(name, value);
        }

        // Build the updated URL
        const baseUrl = `${window.location.origin}${window.location.pathname}`;
        const updatedParams = urlParams.toString();
        const updatedUrl = updatedParams ? `${baseUrl}?${updatedParams}` : baseUrl;

        // Replace the URL without triggering a full page reload
        history.replaceState({}, '', updatedUrl);
        fetchAndReplaceProductGrid(updatedUrl);
        // window.location.reload();
    });
});
const urlParams = new URLSearchParams(window.location.search);

// Function to check if option should have "borderadd" class
function updateOptionClass(name, value) {
    Array.from(options).forEach(element => {
        const optionName = element.getAttribute('name');
        const optionValue = element.getAttribute('value');

        if (optionName === name && optionValue === value) {
            if (!element.classList.contains('borderadd')) {
                element.classList.add('borderadd');
            }
        }
    });
}

// Loop through URL parameters
urlParams.forEach((paramValue, paramName) => {
    updateOptionClass(paramName, paramValue);
});





//  here is the code for Price Ranges.
// Function to update URL parameters
function updateURLParameter(name, value) {
    const url = new URL(window.location);
    url.searchParams.set(name, value);
    history.replaceState({}, '', url);
    fetchAndReplaceProductGrid(url);
}

// Event listener for input changes
document.addEventListener('input', function (event) {
    const inputElement = event.target;

    // Check if the input element has the desired class
    if (inputElement.classList.contains('price_gte') || inputElement.classList.contains('price_lte')) {
        // console.log('running')
        const paramName = inputElement.name;
        const paramValue = inputElement.value;

        // Update the URL parameter
        updateURLParameter(paramName, paramValue);
    }
    // window.location.reload();
});


function checkAndUpdateInputFromURL(paramName, inputSelector) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(paramName);
    const inputElement = document.querySelector(inputSelector);

    if (inputElement) {
        if (paramName === 'filter.v.price.gte' && paramValue === null) {
            inputElement.value = '0';
        } else if (paramValue !== null && inputElement.value !== paramValue) {
            inputElement.value = paramValue;
        }
    }
}

// Call the functions when the page loads
document.addEventListener('DOMContentLoaded', function () {
    checkAndUpdateInputFromURL('filter.v.price.gte', 'input[name="filter.v.price.gte"]');
    checkAndUpdateInputFromURL('filter.v.price.lte', 'input[name="filter.v.price.lte"]');
});


// const priceInput = document.getElementById('price_input');

// priceInput.addEventListener('focus', () => {
//   priceInput.closest('.price_range_option_inner_input_container').classList.add('focus');
// });

// priceInput.addEventListener('blur', () => {
//   priceInput.closest('.price_range_option_inner_input_container').classList.remove('focus');
// });


const filterButton = document.getElementById('filter-button');
filterButton.addEventListener('click', () => {
    const collectionfilters = document.querySelector('.collection-filters');
    collectionfilters.classList.add('collection-filters-open');
})

const closeFilters = document.querySelector('.close-filters');
closeFilters.addEventListener('click', () => {
    const collectionfilters = document.querySelector('.collection-filters');
    collectionfilters.classList.remove('collection-filters-open');
})

// Get the filter button container
const filterButtonContainer = document.querySelector('.button-filter-sort');
const filterButtonStickyClass = 'filter-button-sticky';
let lastPosition = 0;
// Calculate the position from the top of the document
const positionFromTopOfButton = filterButtonContainer.getBoundingClientRect().top + window.pageYOffset - 20;

// product gird to add margin top when filter button is sticky it will help to make the button fludity smooth.
const productGrid = document.querySelector('#product-grid');
console.log(productGrid);
// Event listener for scroll
window.addEventListener('scroll', () => {
    // Get the current scroll position
    const currentScrollPos = window.scrollY;

    if (currentScrollPos >= positionFromTopOfButton) {
        productGrid.style.marginTop = filterButtonContainer.offsetHeight+15 + 'px';
      if(currentScrollPos < lastPosition) {
        filterButtonContainer.style.zIndex = 2;
        lastPosition = currentScrollPos;
        // console.log(lastPosition)
    } else {
        filterButtonContainer.style.zIndex = 3;
        lastPosition = currentScrollPos;
        // console.log(lastPosition)
      }
        // Add the sticky class if it's not already added
        if (!filterButtonContainer.classList.contains(filterButtonStickyClass)) {
            filterButtonContainer.classList.add(filterButtonStickyClass);
        }

    } else {
        productGrid.style.marginTop = "0px";
        // Remove the sticky class if it's added
        if (filterButtonContainer.classList.contains(filterButtonStickyClass)) {
            filterButtonContainer.classList.remove(filterButtonStickyClass);
        }
    }
});






// const selectElement = document.getElementById("SortByFilter");

// selectElement.addEventListener("change", function (e) {
//     e.preventDefault()
//     const selectedOption = selectElement.options[selectElement.selectedIndex];
//     const selectedValue = selectedOption.value;
//     console.log("Selected option:", selectedValue);
// });


  


